import React, { useState } from 'react';
import { Drawer, Radio, RadioGroup, Input, InputGroup, useToaster, Message } from 'rsuite';
const divStyle = {
  border: '1px solid rgba(128, 128, 128, 0.293)',
  borderRadius: '5px',
  padding: '10px 10px 10px 0px'
};
const styles = {
  marginBottom: 5
};
const Daction = {
  textAlign: 'left',
  padding: '10px',
  gap: '5px',
  display: 'flex',
  flexDirection: 'column'
};

export default function GenerateAccess({ open, close, typeCode, setMobileList, mobileList }) {
  const [value, setValue] = React.useState('Allow');
  const [newMobile, setNewMobile] = useState('');
  const toaster = useToaster();
  const handleAddList = () => {
    if (newMobile.trim() !== '') {
      if (mobileList.some(item => item.mobileno === newMobile.trim())) {
        toaster.push(
          <Message showIcon type="error">
            Mobile number already exists in the list!
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        setMobileList(prevList => [
          ...prevList,
          { mobileno: newMobile.trim(), typecode: typeCode, mobilests: true }
        ]);
        setNewMobile('');
      }
    }
  };

  return (
    <Drawer open={open} onClose={close} size="xs" backdrop="static">
      <Drawer.Header>
        <Drawer.Title>
          <h5>Restrict Access</h5>
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <Drawer.Actions style={Daction}>
          <div>
            <RadioGroup name="radioList" inline value={value} onChange={setValue}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px',
                  flexDirection: 'column'
                }}
              >
                <div style={divStyle}>
                  <Radio value="Allow">
                    <h6>Allow Specific Mobile's</h6>
                    Allow specified mobile to access your catalogue while blocking everyone else.
                  </Radio>
                </div>
              </div>
            </RadioGroup>
          </div>

          <div style={{ marginTop: '20px' }}>
            <label htmlFor="">Mobile no.</label>
            <InputGroup inside style={styles}>
              <Input
                type="mobile"
                value={newMobile}
                onChange={value => setNewMobile(value)}
                style={{ width: '100% !important' }}
              />
              <InputGroup.Button onClick={handleAddList}>Allow</InputGroup.Button>
            </InputGroup>
          </div>
          {mobileList.length &&
            mobileList.map(item => {
              return (
                <InputGroup inside style={styles} key={item.mobileno}>
                  <Input disabled value={item.mobileno} />
                </InputGroup>
              );
            })}
        </Drawer.Actions>
      </Drawer.Body>
    </Drawer>
  );
}
